import axios from "axios";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as API_URL from "../../constants/ApiUrl";
import {GET_FAQ_LIST_QUERY} from "../../constants/query/FaqList.query";
import List from "../common/list/List";
import {InitialListProps, ListColumnType, ListProps} from "../common/list/List.props";
import Pagination from "../common/pagination/Pagination";
import Popup from "../common/popup/Popup";
import {PopupProps} from "../common/popup/Popup.props";
import Toast from "../common/toast/Toast";
import * as FAQ_LIST_PROPS from "./constant/FaqList.props";
import {FaqDto} from "./dto/Faq.dto";
import "./style.css";
import {InitialPaginationProps, PaginationProps} from "../common/pagination/Pagination.props";
import {FaqSearchFormProps} from "./constant/SearchForm.props";
import {Option} from "../common/searchForm/Option";
import SearchForm from "../common/searchForm/SearchForm";
import {saveAs} from "file-saver";

export default function Faq() {
    const navigate = useNavigate();

    const [checkedSeqs, setCheckedSeqs] = React.useState<number[]>([]);
    const [deletedSeq, setDeletedSeq] = useState<number>(0);

    const searchProps = FaqSearchFormProps;
    const [paginationProps, setPaginationProps] = useState<PaginationProps>(InitialPaginationProps);
    const [listProps, setListProps] = useState<ListProps<FaqDto>>(InitialListProps);
    const [totalCount, setTotalCount] = useState<number>(0);

    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const [toastProps, setToastProps] = useState<string[]>([]);

    useEffect(() => {
        setListProps({
            headers: [...FAQ_LIST_PROPS.HEADERS, {
                type: ListColumnType.BUTTON,
                name: "",
                key: "",
                button: {
                    name: "상세 보기",
                    onClick: (seq: number) => onDetailClick(seq)
                }
            }],
            items: [],
            emptyProps: FAQ_LIST_PROPS.EMPTY_PROPS(() => onDetailClick(0)),
            onCheckedChange: (seqs: number[]) => setCheckedSeqs(seqs)
        });
        setPaginationProps(prevState => ({
            ...prevState,
            onChange: changePage
        }));
        searchProps.onSearch = () => getFAQs();
        searchProps.onUpdate = (options: Option[]) => {
            searchProps.options = options;
        }
    }, []);

    const changePage = (page: number) => {
        setPaginationProps(prevState => ({
            ...prevState,
            currentPage: page
        }));
    }

    useEffect(() => {
        getFAQs();
    }, [paginationProps.currentPage, deletedSeq]);

    const getFAQs = () => {
        const category = searchProps.options[0].value;
        const keyword = searchProps.options[1].value;

        axios.post(API_URL.GRAPHQL, {query: GET_FAQ_LIST_QUERY(category, keyword, paginationProps.currentPage)})
            .then(response => {
                const faqResponse = response.data.data.getFAQs;

                setPaginationProps(prevState => ({
                    ...prevState,
                    totalPage: faqResponse.totalPage,
                    currentPage: faqResponse.currentPage
                }));
                setTotalCount(faqResponse.totalItems);
                setListProps(prevState => ({
                    ...prevState,
                    items: faqResponse.items
                }));
            });
    };

    const handleToastClose = () => {
        setToastProps(toastProps.slice(1));
    }

    const onDetailClick = (seq: number) => {
        navigate("/FAQ/detail", {state: {seq: seq}});
    }

    const onDeleteButtonClick = () => {
        let message: string = "";

        if (checkedSeqs.length === 0) {
            message = "삭제할 FAQ를 선택해 주세요.";
        } else {
            message = "선택한 FAQ를 삭제하시겠습니까?";
        }

        setPopupProps({
            subject: "FAQ 삭제",
            message1: message,
            message2: null,
            buttonName: "확인",
            onConfirm: () => {
                setPopupProps(null);
                if (checkedSeqs.length !== 0) {
                    deleteFaqs();
                }
            },
            useCloseButton: checkedSeqs.length !== 0,
            onClose: () => setPopupProps(null)
        });
    }

    const deleteFaqs = () => {
        axios.delete(API_URL.FAQ_DELETE, {data: {seqs: checkedSeqs}})
            .then(() => {
                setToastProps([...toastProps, "FAQ가 삭제되었습니다."]);
                setDeletedSeq(checkedSeqs[0]);
            });
    }

    return (
        <>
            <div className="FAQ-management">
                <main className="wrapper">
                    <div className="FAQ-body">
                        <section className="list-search-section">
                            <div className="title">
                                FAQ 관리
                            </div>
                            <SearchForm {...searchProps}/>
                        </section>
                        <div className="FAQ-numbers">
                            <div className="FAQ-wrapper">
                                <div className="FAQ-all-number">
                                    전체 FAQ 수 {totalCount}개
                                </div>
                                <div className="FAQ-choice">
                                    <button className="delete" onClick={onDeleteButtonClick}>
                                        선택항목 일괄삭제
                                    </button>
                                    <button className="insert" onClick={() => onDetailClick(0)}>
                                        FAQ 추가하기
                                    </button>
                                </div>
                            </div>
                            <List {...listProps}/>
                        </div>
                        <Pagination {...paginationProps}/>
                    </div>
                </main>
            </div>
            {popupProps && <Popup data={popupProps}/>}
            {
                toastProps.map((toastProp, index) => {
                    return (
                        <Toast message={toastProp} onClose={handleToastClose} key={index}></Toast>
                    )
                })
            }
        </>
    );
}
